import Http from "@/api/http/fetch/index";
import router from "@/router/router";
import EventBus from "@/utils/eventBus";

const getCurrentRouterName = () => {
  return router.history ? router.history.current.name : "";
};

//======================= Kill App =========================
const killAppRouterName: any = [
  "Followers",
  "Posts",
  "More",
  "SubsLike",
  "SubsFollower",
  "CoinsContainer",
  "EarnCoin"
];
let killAppInfoTimer: any = null;
let killAppCount: number = 0;
const killAppInfo = (fn?: any) => {
  if (killAppCount >= 1) {
    fn && fn();
    Http.KillApp();
    clearTimeout(killAppInfoTimer);
  }
  killAppCount += 1;
  EventBus.$emit("toast-show", {
    type: "warning",
    content: "press to close the app again",
    duration: 2000
  });
  killAppInfoTimer = setTimeout(() => {
    killAppCount = 0;
  }, 1000);
};

//====================== Map Fn =========================

const statckFn = new Map();
export const DIALOG_KEY = "dialog";
export const ACTION_SHEET_KEY = "action_sheet_key";
export const DAILY_CHECK_IN = "daily_check_in";
export const LITE_SERCAH_POP = "lite_search_pop";
export const SEND_OFFER_NOTICE = 'sent_offer_notice';
export const GET_NOW = 'GET_NOW';
export const CASINO_TIPS = 'CASINO_TIPS';
export const RATE_US = 'RATE_US';
export const BUY_VIP_SEND_COIN = 'BUY_VIP_SEND_COIN';
export const SUPER_PAY = 'SUPER_PAY';
export const RECOMMEND_OFFER = 'RECOMMEND_OFFER';
export const FREE_FOLLOWERS = 'FREE_FOLLOWERS';
export const SUPER_PAY_LAUNCH_RETAIN_DIALOG = "SUPER_PAY_LAUNCH_RETAIN_DIALOG";
export const SUPER_PAY_TOAST = "SUPER_PAY_TOAST";

const runBackPressFn = () => {
  //执行安卓的返回
  console.log("runBackPressFn", {
    statckFn,
    router
  });

  if (statckFn.has(DIALOG_KEY)) {
    statckFn.get(DIALOG_KEY)();
    return;
  }

  if (statckFn.has(LITE_SERCAH_POP)) {
    statckFn.get(LITE_SERCAH_POP)();
    return;
  }

  if (statckFn.has(ACTION_SHEET_KEY)) {
    statckFn.get(ACTION_SHEET_KEY)();
    return;
  }

  if (statckFn.has(DAILY_CHECK_IN)) {
    statckFn.get(DAILY_CHECK_IN)();
    return;
  }
  if (statckFn.has(GET_NOW)) {
    statckFn.get(GET_NOW)();
    return;
  }
  if (statckFn.has(CASINO_TIPS)) {
    statckFn.get(CASINO_TIPS)();
    return;
  }
  if (statckFn.has(RATE_US)) {
    statckFn.get(RATE_US)();
    return;
  }
  if (statckFn.has(BUY_VIP_SEND_COIN)) {
    statckFn.get(BUY_VIP_SEND_COIN)();
    return;
  }
  if (statckFn.has(SUPER_PAY)) {
    statckFn.get(SUPER_PAY)();
    return;
  }
  if (statckFn.has(SUPER_PAY_LAUNCH_RETAIN_DIALOG)) {
    statckFn.get(SUPER_PAY_LAUNCH_RETAIN_DIALOG)();
    return;
  }
  if (statckFn.has(SUPER_PAY_TOAST)) {
    statckFn.get(SUPER_PAY_TOAST)();
    return;
  }
  if (statckFn.has(RECOMMEND_OFFER)) {
    statckFn.get(RECOMMEND_OFFER)();
    return;
  }
  if (statckFn.has(FREE_FOLLOWERS)) {
    statckFn.get(FREE_FOLLOWERS)();
    return;
  }

  console.log('getCurrentRouterName:', getCurrentRouterName())

  if (statckFn.has(getCurrentRouterName())) {
    statckFn.get(getCurrentRouterName())();
    return;
  }

  console.log('getCurrentRouterName:', getCurrentRouterName())
  console.log(killAppRouterName)

  if (killAppRouterName.includes(getCurrentRouterName())) {
    //如果包含了主页面的路由需要提示是否关闭App
    if(statckFn.has(SEND_OFFER_NOTICE)) {
      killAppInfo(statckFn.get(SEND_OFFER_NOTICE));
    } else {
      killAppInfo();
    }
  }
};

//====================== Back Press Class ===============
export default {
  initial() {
    Http.BackPressed(runBackPressFn);
  },
  listen(data: any) {
    const { key, fn } = data;
    statckFn.set(key, fn);
  },
  destroy(key: string) {
    console.log("destroy:", key);
    statckFn.has(key) ? statckFn.delete(key) : void 0;
  }
};
